function countMatches(str, pattern) {
    const regex = new RegExp(pattern, 'g');
    const matches = str.match(regex);
    return matches ? matches.length : 0;
}

export default {
    data() {
        return {
            fastStr: null
        }
    },
    methods: {
        textareaInput() {
            let str = this.fastStr
            let delimiter = '=';
            if (str) {
                const keys = [
                        "特单","特双","特大","特小",
                        "合单","合双","合大","合小",
                        "特尾大","特尾小","合尾大","合尾小",
                        "红波","蓝波","绿波",
                        "家禽","野兽",
                        "鼠","牛","虎","兔","龙","蛇","马","羊","猴","鸡","狗","猪",
                        '0头','1头','2头','3头','4头',
                        '0尾','1尾','2尾','3尾','4尾','5尾','6尾','7尾','8尾','9尾',
                        "红单","红双","红大","红小",
                        "蓝单","蓝双","蓝大","蓝小",
                        "绿单","绿双","绿大","绿小",
                        "小单","小双","大单","大双",
                        "金","木","水","火","土",
                        "天肖","地肖","阴性","阳性","女肖","男肖","单笔","双笔"
                ];
                //console.log(112233,this.$store.state.base.options)
                const red_wave = this.$store.state.base.options.lhc_red_wave.split(',').map(Number);
                const bule_wave = this.$store.state.base.options.lhc_blue_wave.split(',').map(Number);
                const green_wave = this.$store.state.base.options.lhc_green_wave.split(',').map(Number);
                const mouse = this.$store.state.base.options.lhc_mouse.split(',').map(Number);//lhc_mouse
                const cattle = this.$store.state.base.options.lhc_cattle.split(',').map(Number);//lhc_cattle
                const tiger = this.$store.state.base.options.lhc_tiger.split(',').map(Number);
                const rabbit = this.$store.state.base.options.lhc_rabbit.split(',').map(Number);
                const dragon = this.$store.state.base.options.lhc_dragon.split(',').map(Number);
                const snake = this.$store.state.base.options.lhc_snake.split(',').map(Number);
                const horse = this.$store.state.base.options.lhc_horse.split(',').map(Number);
                const sheep = this.$store.state.base.options.lhc_sheep.split(',').map(Number);
                const monkey = this.$store.state.base.options.lhc_monkey.split(',').map(Number);
                const chicken = this.$store.state.base.options.lhc_chicken.split(',').map(Number);
                const dog = this.$store.state.base.options.lhc_dog.split(',').map(Number);
                const pig = this.$store.state.base.options.lhc_pig.split(',').map(Number);
                //const mergedArray = [...array1, ...array2, ...array3]; //马,牛,羊,鸡,狗,猪
                //const poultry = [12,24,36,48,5,17,29,41,11,23,35,47,9,21,33,45,8,20,32,44,7,19,31,43];
                const poultry = [...horse,...cattle,...sheep,...chicken,...dog,...pig];
                //鼠,虎,兔,龙,蛇,猴
                //const beast = [6,18,30,42,4,16,28,40,3,15,27,39,2,14,26,38,1,13,25,37,49,10,22,34,46];
                const beast = [...mouse,...tiger,...rabbit,...dragon,...snake,...monkey];
                const wuxing_jin = this.$store.state.base.options.jin_zodiac.split(',').map(Number);
                const wuxing_mu = this.$store.state.base.options.mu_zodiac.split(',').map(Number);
                const wuxing_shui = this.$store.state.base.options.shui_zodiac.split(',').map(Number);
                const wuxing_huo = this.$store.state.base.options.huo_zodiac.split(',').map(Number);
                const wuxing_tu = this.$store.state.base.options.tu_zodiac.split(',').map(Number);
                const sky_zodiac = [...rabbit,...horse,...monkey,...pig,...cattle,...dragon];//兔,马,猴,猪,牛,龙
                const earth_zodiac = [...snake,...sheep,...chicken,...dog,...mouse,...tiger];//蛇,羊,鸡,狗,鼠,虎
                const yin_zodiac = [...mouse,...dragon,...snake,...horse,...dog,...pig];//鼠,龙,蛇,马,狗,猪
                const yang_zodiac = [...cattle,...tiger,...rabbit,...sheep,...monkey,...chicken];//牛,虎,兔,羊,猴,鸡
                const woman_zodiac = [...rabbit,...snake,...sheep,...chicken,...pig];//兔,蛇,羊,鸡,猪
                const man_zodiac = [...mouse,...cattle,...tiger,...dragon,...horse,...monkey,...dog];//鼠,牛,虎,龙,马,猴,狗
                const danbi_zodiac = [...mouse,...dragon,...horse,...snake,...chicken,...pig];//鼠,龙,马,蛇,鸡,猪
                const shuangbi_zodiac = [...tiger,...monkey,...dog,...rabbit,...sheep,...cattle];//虎,猴,狗,兔,羊,牛
                if(str.includes('各')){
                    delimiter = '各';
                }
                if(str.includes('各数')){
                    delimiter = '各数';
                }
                let list = str.split(' ')
                let obj = {}
                let error = 0
                while (list.length >= 1) {
                    let ball = list.splice(0, 1)[0].split(delimiter)
                    let code = ball[0];
                    let amount = Number(ball[1])
                    
                    if(code.includes(".")){
                        let dian = code.split('.')
                        while(dian.length >=1){
                            let dian_ball = dian.splice(0, 1)[0].split('.')
                            let dian_var = dian_ball[0];
                            if(/^\d+$/.test(dian_var)){
                                dian_var = Number(dian_var);
                            }
                            if(dian_var in obj){
                                obj[dian_var] = obj[dian_var] + amount
                            }else{
                                obj[dian_var] = amount
                            }
                        }
                    }else if(code.includes("-")){
                        let gang = code.split('-')
                        while(gang.length >=1){
                            let gang_ball = gang.splice(0, 1)[0].split('-')
                            let gang_var = gang_ball[0];
                            if(/^\d+$/.test(gang_var)){
                                gang_var = Number(gang_var);
                            }
                            if(gang_var in obj){
                                obj[gang_var] = obj[gang_var] + amount
                            }else{
                                obj[gang_var] = amount
                            }
                        }
                    }else if(code.includes("/")){
                        let xiegang = code.split('/')
                        while(xiegang.length >=1){
                            let xiegang_ball = xiegang.splice(0, 1)[0].split('/')
                            let xiegang_var = xiegang_ball[0];
                            if(/^\d+$/.test(xiegang_var)){
                                xiegang_var = Number(xiegang_var);
                            }
                            if(xiegang_var in obj){
                                obj[xiegang_var] = obj[xiegang_var] + amount
                            }else{
                                obj[xiegang_var] = amount
                            }
                        }
                    }else if(code.includes(",")){
                        let douhao = code.split(',')
                        while(douhao.length >=1){
                            let douhao_ball = douhao.splice(0, 1)[0].split(',')
                            let douhao_var = douhao_ball[0];
                            if(/^\d+$/.test(douhao_var)){
                                douhao_var = Number(douhao_var);
                            }
                            if(douhao_var in obj){
                                obj[douhao_var] = obj[douhao_var] + amount
                            }else{
                                obj[douhao_var] = amount
                            }
                        }
                    }else{
                        if(/^\d+$/.test(code)){
                            code = Number(code);
                            if(code in obj){
                                obj[code] = obj[code] + amount
                            }else{
                                obj[code] = amount
                            }
                        }else{
                            keys.forEach(key=>{
                                if (!key) return;
                                if(code.includes(key)){
                                    if(key == '特单' || key == '小单' || key == '大单'){
                                        for (let i = 1; i < 49; i+=2) { 
                                            if(key == '小单' && i < 25){
                                                let multiply = countMatches(code,'小单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '大单' && i > 24){
                                                let multiply = countMatches(code,'大单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '特单'){
                                                let multiply = countMatches(code,'特单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                         }
                                    }else if(key == '特双' || key == '小双' || key == '大双'){
                                        for (let i = 2; i < 49; i+=2) { 
                                            if(key == '小双' && i < 25){
                                                let multiply = countMatches(code,'小双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '大双' && i > 24){
                                                let multiply = countMatches(code,'大双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '特双'){
                                                let multiply = countMatches(code,'特双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                         }
                                    }else if(key == '特大'){
                                        let multiply = countMatches(code,'特大')
                                        for (let i = 25; i < 49; i++) { 
                                            if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                         }
                                    }else if(key == '特小'){
                                        let multiply = countMatches(code,'特小')
                                        for (let i = 1; i < 25; i++) { 
                                            if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                        }
                                    }else if(key == '合单' || key == '合双'){
                                        for (let i = 1; i < 49; i++) { 
                                            let number = i;
                                            if(i > 9){
                                                let num = i;
                                                const str_num = num.toString();
                                                let number1 = parseInt(str_num[0]);
                                                let number2 = parseInt(str_num[1]);
                                                number = number1 + number2;
                                            }
                                            if(key == '合单' && number % 2 > 0){
                                                let multiply = countMatches(code,'合单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                             if(key == '合双' && number % 2 === 0){
                                                let multiply = countMatches(code,'合双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                        }
                                    }else if(key == '合大' || key == '合小'){
                                        for (let i = 1; i < 49; i++) { 
                                            let number = i;
                                            if(i > 9){
                                                let num = i;
                                                const str_num = num.toString();
                                                let number1 = parseInt(str_num[0]);
                                                let number2 = parseInt(str_num[1]);
                                                number = number1 + number2;
                                            }
                                            if(key == '合大' && number > 6){
                                                let multiply = countMatches(code,'合大')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                             if(key == '合小' && number <= 6){
                                                let multiply = countMatches(code,'合小')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                        }
                                    }else if(key == '红波' || key == '红单' || key == '红双' || key == '红大' || key == '红小'){
                                        for (let i of red_wave) {
                                            if(key == '红单' && i%2 > 0){
                                                let multiply = countMatches(code,'红单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '红双' && i%2 === 0){
                                                let multiply = countMatches(code,'红双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '红大' && i > 24){
                                                let multiply = countMatches(code,'红大')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '红小' && i < 25){
                                                let multiply = countMatches(code,'红小')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '红波'){
                                                let multiply = countMatches(code,'红波')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                        }
                                    }else if(key == '蓝波' || key == '蓝单' || key == '蓝双' || key == '蓝大' || key == '蓝小'){
                                        for (let i of bule_wave) {
                                           if(key == '蓝单' && i%2 > 0){
                                                let multiply = countMatches(code,'蓝单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '蓝双' && i%2 === 0){
                                                let multiply = countMatches(code,'蓝双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '蓝大' && i > 24){
                                                let multiply = countMatches(code,'蓝大')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '蓝小' && i < 25){
                                                let multiply = countMatches(code,'蓝小')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '蓝波'){
                                                let multiply = countMatches(code,'蓝波')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                        }
                                    }else if(key == '绿波' || key == '绿单' || key == '绿双' || key == '绿大' || key == '绿小'){
                                        for (let i of green_wave) {
                                           if(key == '绿单' && i%2 > 0){
                                                let multiply = countMatches(code,'绿单')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '绿双' && i%2 === 0){
                                                let multiply = countMatches(code,'绿双')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '绿大' && i > 24){
                                                let multiply = countMatches(code,'绿大')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '绿小' && i < 25){
                                                let multiply = countMatches(code,'绿小')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            }
                                            if(key == '绿波'){
                                                let multiply = countMatches(code,'绿波')
                                                if(i in obj){
                                                    obj[i] += amount * multiply
                                                }else{
                                                    obj[i] = amount * multiply
                                                }
                                            } 
                                        }
                                    }else if(key == '家禽'){
                                        let multiply = countMatches(code,'家禽')
                                        for (let i of poultry) {
                                            if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '野兽'){
                                        let multiply = countMatches(code,'野兽')
                                        for (let i of beast) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '鼠'){
                                        let multiply = countMatches(code,'鼠')
                                        for (let i of mouse) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '牛'){
                                        let multiply = countMatches(code,'牛')
                                        for (let i of cattle) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '虎'){
                                        let multiply = countMatches(code,'虎')
                                        for (let i of tiger) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '兔'){
                                        let multiply = countMatches(code,'兔')
                                        for (let i of rabbit) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '龙'){
                                        let multiply = countMatches(code,'龙')
                                        for (let i of dragon) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '蛇'){
                                        let multiply = countMatches(code,'蛇')
                                        for (let i of snake) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '马'){
                                        let multiply = countMatches(code,'马')
                                        for (let i of horse) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '羊'){
                                        let multiply = countMatches(code,'羊')
                                        for (let i of sheep) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '猴'){
                                        let multiply = countMatches(code,'猴')
                                        for (let i of monkey) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '鸡'){
                                        let multiply = countMatches(code,'鸡')
                                        for (let i of chicken) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '狗'){
                                        let multiply = countMatches(code,'狗')
                                        for (let i of dog) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '猪'){
                                        let multiply = countMatches(code,'猪')
                                        for (let i of pig) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '0头'){
                                        let multiply = countMatches(code,'0头')
                                        for (let i = 1; i < 10; i++) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply }}
                                    }else if(key == '1头'){
                                        let multiply = countMatches(code,'1头')
                                        for (let i = 10; i < 20; i++) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '2头'){
                                        let multiply = countMatches(code,'2头')
                                        for (let i = 20; i < 30; i++) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '3头'){
                                        let multiply = countMatches(code,'3头')
                                        for (let i = 30; i < 40; i++) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '4头'){
                                        let multiply = countMatches(code,'4头')
                                        for (let i = 40; i < 50; i++) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '0尾'){
                                        let multiply = countMatches(code,'0尾')
                                        for (let i = 10; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '1尾'){
                                        let multiply = countMatches(code,'1尾')
                                        for (let i = 1; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '2尾'){
                                        let multiply = countMatches(code,'2尾')
                                        for (let i = 2; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '3尾'){
                                        let multiply = countMatches(code,'3尾')
                                        for (let i = 3; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '4尾'){
                                        let multiply = countMatches(code,'4尾')
                                        for (let i = 4; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '5尾'){
                                        let multiply = countMatches(code,'5尾')
                                        for (let i = 5; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '6尾'){
                                        let multiply = countMatches(code,'6尾')
                                        for (let i = 6; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '7尾'){
                                        let multiply = countMatches(code,'7尾')
                                        for (let i = 7; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '8尾'){
                                        let multiply = countMatches(code,'8尾')
                                        for (let i = 8; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '9尾'){
                                        let multiply = countMatches(code,'9尾')
                                        for (let i = 9; i < 50; i+=10) { if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply } }
                                    }else if(key == '特尾大' || key == '特尾小'){
                                        for (let i = 1; i < 49; i++) { 
                                            if (key == '特尾大' && i % 10 > 4) {
                                                let multiply = countMatches(code,'特尾大')
                                                if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply }
                                            }
                                            if (key == '特尾小' && i%10 <= 4){
                                                let multiply = countMatches(code,'特尾小')
                                                if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply }
                                            }
                                        }
                                    }else if(key == '合尾大' || key == '合尾小'){
                                        for (let i = 1; i < 49; i++) { 
                                            if(i == 25){
                                                continue;
                                            }
                                            let number = i;
                                            if(i > 9){
                                                let num = i;
                                                const str_num = num.toString();
                                                let number1 = parseInt(str_num[0]);
                                                let number2 = parseInt(str_num[1]);
                                                number = number1 + number2;
                                            }
                                            if(key == '合尾大' && number%10 > 4){
                                                let multiply = countMatches(code,'合尾大')
                                                if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply }
                                            }
                                             if(key == '合尾小' && number%10 <= 4){
                                                let multiply = countMatches(code,'合尾小')
                                                if(i in obj){ obj[i] += amount * multiply }else{ obj[i] = amount * multiply }
                                            }
                                        }
                                    }else if(key == '金'){
                                        let multiply = countMatches(code,'金')
                                        for (let i of wuxing_jin) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '木'){
                                        let multiply = countMatches(code,'木')
                                        for (let i of wuxing_mu) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '水'){
                                        let multiply = countMatches(code,'水')
                                        for (let i of wuxing_shui) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '火'){
                                        let multiply = countMatches(code,'火')
                                        for (let i of wuxing_huo) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '土'){
                                        let multiply = countMatches(code,'土')
                                        for (let i of wuxing_tu) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '天肖'){
                                        let multiply = countMatches(code,'天肖')
                                        for (let i of sky_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '地肖'){
                                        let multiply = countMatches(code,'地肖')
                                        for (let i of earth_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '阴性' || key == '阴肖'){
                                        let multiply1 = countMatches(code,'阴性')
                                        let multiply2 = countMatches(code,'阴肖')
                                        let multiply = parseInt(multiply1 + multiply2);
                                        for (let i of yin_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '阳性' || key == '阳肖'){
                                        let multiply1 = countMatches(code,'阳性')
                                        let multiply2 = countMatches(code,'阳肖')
                                        let multiply = parseInt(multiply1 + multiply2);
                                        for (let i of yang_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '女肖'){
                                        let multiply = countMatches(code,'女肖')
                                        for (let i of woman_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '男肖'){
                                        let multiply = countMatches(code,'男肖')
                                        for (let i of man_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '单笔'){
                                        let multiply = countMatches(code,'单笔')
                                        for (let i of danbi_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else if(key == '双笔'){
                                        let multiply = countMatches(code,'双笔')
                                        for (let i of shuangbi_zodiac) {
                                           if(i in obj){
                                                obj[i] += amount * multiply
                                            }else{
                                                obj[i] = amount * multiply
                                            }
                                        }
                                    }else{
                                        obj[key] = amount
                                    }
                                }
                            }
                            )
                        }
                    }
                    // if (code && code >=1 && code<=49 && amount && this.Is('int', amount) && amount > 0) {
                    //    obj[code] = amount
                    // }
                
                }
                if (this.list && this.list.child) {
                    for (let item of this.list.child) {
                        if (obj[item.name]) {
                            this.$set(item, 'amount', obj[item.name])
                        }
                    }
                }
                this.fastStr = null
            }
        }
    }
}
